/**
 * @file RatioScheme.tsx
 * @description Мини-схема долей колонок: полоски шириной по долям
 * (phase19.16 Р2; SB120 этап 1 — доли из 12, uiux-sb120-stage1 §2.5 —
 * быстрые схемы «▌▌ 6+6», «▌▌ 8+4»).
 */

export function RatioScheme({ shares }: { shares: readonly number[] }) {
  return (
    <span className="flex h-6 w-full gap-1">
      {shares.map((part, i) => (
        <span key={i} className="rounded-sm bg-primary/60" style={{ flexGrow: part, flexBasis: 0 }} />
      ))}
    </span>
  );
}
